import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { OpenModalContext } from 'common/containers/ModalContainer';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';

import PhotoViewer from '../PhotoViewer';
import Tappable from '../Tappable';

import 'css/components/post/_PostImages.scss';

class PostImages extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    post: PropTypes.shape({
      imageURLs: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    }).isRequired,
  };

  onImageClicked = (index) => {
    this.props.openModal(PhotoViewer, {
      imageURLs: this.props.post.imageURLs,
      defaultIndex: index,
    });
  };

  renderImages() {
    var images = [];
    for (var i = 0; i < this.props.post.imageURLs.length; i++) {
      var imageURL = this.props.post.imageURLs[i];
      images.push(
        <Tappable key={imageURL} onTap={this.onImageClicked.bind(this, i)}>
          <LazyLoadedImage src={imageURL} />
        </Tappable>
      );
    }

    return images;
  }

  render() {
    if (!this.props.post || !this.props.post.imageURLs || this.props.post.imageURLs.length === 0) {
      return null;
    }

    return (
      <div className="postImages">
        <div>{this.renderImages()}</div>
      </div>
    );
  }
}

export default withContexts({
  openModal: OpenModalContext,
})(PostImages);
